/* Análise → Evolução mensal: acumulado no ano e tabela mês a mês. */

import { api } from '../../core/api';
import { lista, MESES, nf, num } from '../../core/formato';
import type { Mes } from '../../tipos/api';
import { carregar } from '../../ui/carregar';
import { loading, tabela, vazio } from '../../ui/componentes';
import { ic } from '../../ui/dom';
import { filtrosBar, paramsFiltro } from '../../ui/filtros';
import { linhasEscopo } from '../../ui/graficos';
import { exportarMensal } from '../relatorios/exportacoes';
import type { Pagina } from '../pagina';

export const evolucao: Pagina = {
  render: () => `
  <div class="between wrap"><div><h1 class="page">Evolução mensal</h1>
  <p class="sub">Emissões mês a mês e acumuladas no ano, separadas por escopo.</p></div>
  <button class="btn btn-ghost no-print" data-clique="exportar">${ic('i-dl')} Exportar CSV</button></div>
  ${filtrosBar({ escopo: true })}
  <div class="card" style="margin-bottom:16px"><div class="kpi-title" style="margin-bottom:6px">Acumulado no ano</div>
    <div class="legend">
      <span><i style="background:var(--esc1)"></i>Escopo 1</span>
      <span><i style="background:var(--esc2)"></i>Escopo 2</span>
      <span><i style="background:var(--esc3)"></i>Escopo 3</span>
      <span><i style="background:var(--serie-total)"></i>Total</span></div>
    <div id="aAcum">${loading()}</div></div>
  <div id="aMensal">${loading()}</div>`,

  carregar(tk) {
    const params = paramsFiltro();
    carregar(tk, [
      {
        id: 'aAcum',
        busca: () => api<Mes[]>('GET', '/acumulado', { params }),
        html: (d: Mes[]) => (lista<Mes>(d).some((m) => num(m.total_emissoes)) ? linhasEscopo(lista<Mes>(d)) : vazio()),
      },
      {
        id: 'aMensal',
        busca: () => api<Mes[]>('GET', '/mensal', { params }),
        html: (d: Mes[]) => {
          const l = lista<Mes>(d);
          const soma = (k: keyof Mes) => l.reduce((a, x) => a + num(x[k]), 0);
          return tabela<Mes>([
            { l: 'Mês', f: (x) => `<b>${MESES[x.mes - 1] || x.mes}</b>` },
            { l: 'Escopo 1', r: true, f: (x) => nf(x.escopo_1, 2) },
            { l: 'Escopo 2', r: true, f: (x) => nf(x.escopo_2, 2) },
            { l: 'Escopo 3', r: true, f: (x) => nf(x.escopo_3, 2) },
            { l: 'Total tCO₂e', r: true, f: (x) => `<b>${nf(x.total_emissoes, 2)}</b>` },
          ], l, ['Ano', nf(soma('escopo_1'), 2), nf(soma('escopo_2'), 2), nf(soma('escopo_3'), 2), nf(soma('total_emissoes'), 2)]);
        },
      },
    ]);
  },

  acoes: { exportar: () => exportarMensal() },
};
